/**
 * CheckboxWidget component.
 * @module components/manage/Widgets/CheckboxWidget
 */

import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import { FormFieldWrapper } from '@plone/volto/components';
import warningSVG from '../../theme/images/warning.svg';
import clearSVG from '../../theme/images/clear.svg';


const parent_id = "responsabile-parent";
const middle_id = "responsabile-middle";
const field_id = "responsabile-field";

function updateResponsabileDiv(isResponsabile, scheda_id) {
    const responsabileField = document.getElementById(field_id);
    const responsabileParent = document.getElementById(parent_id);
    if (!responsabileField) {
        return null;
    }
    responsabileParent.classList.add('fade');
    var responsabile_id;
    if (responsabileField.href.includes('/rubrica/') && !responsabileField.href.includes('#')) {
        responsabile_id = responsabileField.href.split('/rubrica/')[1];
    } else {
        responsabileField.removeAttribute("href");
        responsabileField.innerHTML = "Nessuno"
    }
    setTimeout(() => {
        if (isResponsabile) {
            if (responsabile_id == scheda_id) {
                responsabileParent.className = 'strutturaAfferenza-responsabile m-2 p-2 already';
                responsabileParent.innerHTML = `
                                <div id="${middle_id}">
                                Sei già il responsabile della struttura selezionata! ${responsabileField.outerHTML}
                                </div>
                            `;
            } else {
                responsabileParent.className = 'strutturaAfferenza-responsabile m-2 p-2 active';
                responsabileParent.innerHTML = `
                            <img src="${warningSVG}" alt="Warning Icon" />
                            <div id="${middle_id}">
                            Si sta dichiarando di essere il Responsabile della struttura. <br/>
                            Attualmente, nel sistema, ${responsabileField.outerHTML} risulta responsabile della struttura selezionata.
                            </div>
                        `;
            }
        } else {
            if (responsabile_id == scheda_id) {
                responsabileParent.className = 'strutturaAfferenza-responsabile m-2 p-2 remove';
                responsabileParent.innerHTML = `
                            <img src="${clearSVG}" alt="Clear Icon" />
                            <div id="${middle_id}">
                            Responsabile della struttura selezionata: ${responsabileField.outerHTML}. <br />
                            Sicuro di volerti rimuovere come responsabile?
                            </div>
                        `;
            } else {
                responsabileParent.className = 'strutturaAfferenza-responsabile m-2 p-2';
                responsabileParent.innerHTML = `
                            <div id="${middle_id}">
                            Responsabile della struttura selezionata: ${responsabileField.outerHTML}
                            </div>
                        `;
            }
        }
        setTimeout(() => {
            responsabileParent.classList.remove('fade');
        }, 200);
    }, 300);
}

/**
 * CheckboxWidget component class.
 * @function CheckboxWidget
 * @returns {string} Markup of the component.
 *
 * To use it, in schema properties, declare a field like:
 *
 * ```jsx
 * {
 *  title: "Active",
 *  type: 'boolean',
 * }
 * ```
 */
const CheckboxResponsabileWidget = (props) => {
    const { id, title, value, onChange, isDisabled } = props;

    return (
        <FormFieldWrapper {...props} columns={1}>
            <div className="wrapper">
                <Checkbox
                    name={`field-${id}`}
                    checked={value}
                    disabled={isDisabled}
                    onChange={(event, { checked }) => {
                        onChange(id, checked);
                        updateResponsabileDiv(checked, props.formData.id);
                    }}
                    label={<label htmlFor={`field-${id}`}>{title}</label>}
                />
            </div>
        </FormFieldWrapper>
    );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
CheckboxResponsabileWidget.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    required: PropTypes.bool,
    error: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.bool,
    onChange: PropTypes.func,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    wrapped: PropTypes.bool,
};

/**
 * Default properties.
 * @property {Object} defaultProps Default properties.
 * @static
 */
CheckboxResponsabileWidget.defaultProps = {
    description: null,
    required: false,
    error: [],
    value: null,
    onChange: null,
    onEdit: null,
    onDelete: null,
};

export default injectIntl(CheckboxResponsabileWidget);
